module.exports = __webpack_public_path__ + "img/logo_chatluck.6b67d348.png";